import styled from "styled-components";
import theme from "~/styles/theme";

export const AccordionHolder = styled.div`
  * {
    border: none;
    box-shadow: none;
    background-color: transparent;
  }

  .MuiAccordion-root {
    border-top: 1px solid ${theme.palette.neutral.primary.key};
    border-bottom: none;
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
  }

  .MuiAccordionSummary-root {
    padding: 0 17px;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      padding: 0;
    }
  }

  .MuiAccordionSummary-content {
    margin: 19px 0;
  }
`;

export const ExpandIcon = styled.div`
  width: 24px;
  height: 24px;
  font-size: 26px;
  color: ${theme.palette.brand.primary.key};
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: ${(props) => (props.expanded ? "10px" : "22px")};
  transform: none;
  font-weight: 500;
`;

export const AccordionQuestion = styled.p`
  color: ${theme.palette.neutral.primary.key};
  font-weight: 600;
  font-size: 18px;
  display: flex;
  align-items: center;
`;

export const SequenceNumber = styled.span`
  color: ${theme.palette.neutral.primary.key};
  font-weight: normal;
  margin-right: 10px;
  font-size: 18px;
`;

export const AccordionAnswer = styled.p`
  color: ${theme.palette.neutral.primary.key};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  padding: 0;
  font-family: ${theme.typography.fontFamilyRegular};

  @media (min-width: ${theme.breakpoints.values.md}px) {
    padding: 0 10px 0 17px;
  }

  ul {
    li {
      margin: 0 0 10px 0;

      @media (min-width: ${theme.breakpoints.values.md}px) {
        margin: 0 0 10px 30px;
      }
    }
  }
`;

export const FAQContainer = styled.div`
  padding: 0 16px;
  max-width: 1200px;
  margin: 0 auto;
  @media (min-width: ${theme.breakpoints.values.md}px) {
    padding: 0 120px;
  }
`;
